import { CHAT_ATTACHMENT_MIME_BY_EXTENSION, CHAT_ATTACHMENT_UNKNOWN_MIME_FALLBACK } from './constants';

const OCTET_STREAM = 'application/octet-stream';

/** The browser's type when present, else one derived from the extension; never `application/octet-stream`. */
export const resolveAttachmentMimeType = (file: File): string => {
    // Browsers themselves report octet-stream for types they don't recognise — treat it as no type at all.
    if (file.type && file.type !== OCTET_STREAM) return file.type;
    const extension = file.name.toLowerCase().split('.').pop() ?? '';
    return CHAT_ATTACHMENT_MIME_BY_EXTENSION[extension] ?? CHAT_ATTACHMENT_UNKNOWN_MIME_FALLBACK;
};
